import axios from "axios";
import { axiosHyperwolfDevClient } from "axiosClient";
import { getQueryString, getData } from "utilities/common";



export async function fetchBrandsAPI(filters) {
  const statusVal = filters?.status;
  const statusQuery =
    statusVal === 'Active' ? true : statusVal === 'Inactive' ? false : undefined;
  const sortBy = filters?.sortBy;
  const order = filters?.order;
  const query = {
    searchTerm: filters?.searchTerm ?? '',
    skip: filters?.skip ?? 0,
    limit: filters?.limit ?? 10,
    ...(statusQuery !== undefined && { status: statusQuery }),
    ...(sortBy ? { sortBy } : {}),
    ...(order ? { order } : {}),
  };
  const res = await axiosHyperwolfDevClient.get(
    `api/v1/admin/brand?${getQueryString(query)}`
  );
  return res?.data ?? res;
}

export async function uploadImageAPI(data) {
  const user = getData("login-user-info");
  const token = user ? JSON.parse(user)?.access_token : null;
  const apiKey = process.env.REACT_APP_IMAGE_UPLOAD_API_KEY || "";
  const res = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/api/v1/upload/image`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "X-API-KEY": apiKey,
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    }
  );
  return res?.data ?? res;
}

export async function addBrandAPI(data) {
  const res = await axiosHyperwolfDevClient.post('api/v1/admin/brand', data);
  return res?.data ?? res;
}

export async function getBrandDetailsAPI(brandId) {
  const res = await axiosHyperwolfDevClient.get(
    `api/v1/admin/brand/${brandId}`
  );
  return res?.data ?? res;
}

export async function updateBrandAPI(brandId, data) {
  const res = await axiosHyperwolfDevClient.put(
    `api/v1/admin/brand/${brandId}`,
    data
  );
  return res?.data ?? res;
}

export async function deleteBrandAPI(brandId) {
  const res = await axiosHyperwolfDevClient.delete(
    `api/v1/admin/brand/${brandId}`
  );
  return res?.data ?? res;
}

export async function syncBrandAPI() {
  const res = await axiosHyperwolfDevClient.get(
    `api/v1/admin/brand/sync/blaze`
  );
  return res?.data ?? res;
}
